let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lhPv3")).then(() => parcelRequire('7Ep0a'));